<template lang="pug">
  b-modal(v-model="show"
          width="30%"
          title="⚠️ Atención"
          no-close-on-backdrop=true
          hide-header-close
          :show-close="false"
          )
    div.modal-body
      p.text Hemos realizado algunos cambios en la aplicación, por favor recarga para continuar.
    div(slot="modal-footer")
      b-btn(variant="primary", @click="realoadApp") Recargar
</template>

<script>
import store from '@/store';
import kexaApi from '@/services/apiService';

export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  watch: {
    showDialog(newValue) {
      this.show = newValue;
    },
  },
  methods: {
    realoadApp() {
      kexaApi.reloadAppToFalse({ id: store.state.id }).then(() => {
        store.commit('setReloadApp', false);
        this.show = false;
        window.location.reload();
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ReloadAppDialog.vue